import PrepaidBalances from './PrepaidBalances';
export default PrepaidBalances;
